import React from 'react';

import Header from 'components/MainLanding//Header';
import MainSection from './MainSection';
import ToolsServicesSection from './ToolsServicesSection';
import OurMissionSection from './OurMissionSection';
import OurTeamSection from './OurTeamSection';
import WhyItMattersSection from './WhyItMattersSection';
import Footer from 'components/MainLanding/Footer';

export default function AboutUsPage() {
  return (
    <>
      <Header />
      <main>
        <MainSection />
        <ToolsServicesSection />
        <OurMissionSection />
        <OurTeamSection />
        <WhyItMattersSection />
      </main>
      <Footer className="footer-corp" />
    </>
  );
}
